import { Children, isValidElement } from "react";
import { Icon } from "../Icon.js";
const containsOnlyUnlabelledIcon = (args) => {
  const { children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy } = args;
  if (ariaLabel || ariaLabelledBy) {
    return false;
  }
  try {
    const onlyChild = Children.only(children);
    if (isValidElement(onlyChild) && onlyChild.type === Icon && !("aria-label" in onlyChild.props || "aria-labelledby" in onlyChild.props)) {
      return true;
    }
  } catch (e) {
  }
  return false;
};
export {
  containsOnlyUnlabelledIcon
};
